import { render } from "./SwiperBanner.vue?vue&type=template&id=f6717338&scoped=true&ts=true"
import script from "./SwiperBanner.vue?vue&type=script&lang=ts"
export * from "./SwiperBanner.vue?vue&type=script&lang=ts"

import "./SwiperBanner.vue?vue&type=style&index=0&id=f6717338&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6717338"]])

export default __exports__